module.exports = __webpack_public_path__ + "img/landing-img.f8e5a7f6.png";